import { BattlePassPrizeType, deserializeData, MayNull } from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { battlePassPrizeSchema } from '@src/deserialize/yup/battlePass'
import graphql from '@src/graphql/query/getCurrentBattlePassPrizeSummary'
import { useCallback, useState } from 'react'

const useGetCurrentBattlePassPrizeSummary = () => {
  const [query, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<Response>(null)

  const fetch = useCallback(async (): Promise<Response> => {
    const response = await query()

    const prizeInfos = deserializeData<Response>(
      response,
      battlePassPrizeSchema,
      undefined,
      ['items']
    )

    setData(prizeInfos)

    return prizeInfos
  }, [query])

  return {
    fetch,
    data,
    loading
  }
}

type Response = MayNull<BattlePassPrizeType[]>

export default useGetCurrentBattlePassPrizeSummary
